import { TOKEN_KEY } from "../../constants/appkeys";
import { BASE_URL } from "../../constants/urls";
import { SessionStorage } from "../../utils/storage";

export enum RequestTypes {
  post = "post",
  put = "put",
  patch = "patch",
  delete = "delete",
  get = "get",
}
interface HeaderAddOn {
  noAuth?: boolean;
}

interface RequestDataType {
  data?: object | any;
  noAuth?: boolean;
}

export async function getHeaders(addOn: HeaderAddOn) {
  const { noAuth = false } = addOn;
  const headers: any = {
    Accept: "application/json",
    "Content-Type": "application/json",
  };

  if (!noAuth) {
    const token = SessionStorage.get(TOKEN_KEY);
    if (token) {
      headers.Authorization = `Bearer ${token}`;
    }
  }

  return headers;
}

export const post = async (endpoint: string, props: RequestDataType) => {
  const { data, noAuth = false } = props;
  const headers = await getHeaders({ noAuth: noAuth });

  return fetch(BASE_URL + endpoint, {
    method: RequestTypes.post,
    headers: headers,
    body: JSON.stringify(data),
  })
    .then((response) => response.json())
    .then((json) => {
      return json;
    })
    .catch((error) => {
      console.error(error, "error");
    });
};

export const get = async (endpoint: string, props: RequestDataType) => {
  const { noAuth = false } = props;
  const headers = await getHeaders({ noAuth: noAuth });

  return fetch(BASE_URL + endpoint, {
    method: RequestTypes.get,
    headers: headers,
  })
    .then((response) => response.json())
    .then((json) => {
      return json;
    })
    .catch((error) => {
      console.error(error, "error");
    });
};
export const del = async (endpoint: string, props: RequestDataType) => {
  const { noAuth = false } = props;
  const headers = await getHeaders({ noAuth: noAuth });
  return fetch(BASE_URL + endpoint, {
    method: RequestTypes.delete,
    headers: headers,
  })
    .then((response) => response.json())
    .then((json) => {
      return json;
    })
    .catch((error) => {
      console.error(error, "error");
    });
};
export const put = async (endpoint: string, props: RequestDataType) => {
  const { data, noAuth = false } = props;
  const headers = await getHeaders({ noAuth: noAuth });

  return fetch(BASE_URL + endpoint, {
    method: RequestTypes.put,
    headers: headers,
    body: JSON.stringify(data),
  })
    .then((response) => response.json())
    .then((json) => {
      return json;
    })
    .catch((error) => {
      console.error(error, "error");
    });
};
export const patch = async (endpoint: string, props: RequestDataType) => {
  const { data, noAuth = false } = props;
  const headers = await getHeaders({ noAuth: noAuth });
  return fetch(BASE_URL + endpoint, {
    method: RequestTypes.patch,
    headers: headers,
    body: JSON.stringify(data),
  })
    .then((response) => response.json())
    .then((json) => {
      return json;
    })
    .catch((error) => {
      console.error(error, "error");
    });
};

//-----------------------------------------------------------------------------------------------

// export const post = async (endpoint: string, data: object) => {
//   return fetch(BASE_URL + endpoint, {
//     method: RequestTypes.post,
//     headers: {
//       Accept: "application/json",
//       "Content-Type": "application/json",
//     },
//     body: JSON.stringify(data),
//   })
//     .then((response) => response.json())
//     .then((json) => {
//       return json;
//     })
//     .catch((error) => {
//       console.error(error, "error");
//     });
// };

// export const get = async (endpoint: string) => {
//   return fetch(BASE_URL + endpoint, {
//     method: RequestTypes.get,
//     headers: {
//       Accept: "application/json",
//       "Content-Type": "application/json",
//     },
//   })
//     .then((response) => response.json())
//     .then((json) => {
//       return json;
//     })
//     .catch((error) => {
//       console.error(error, "error");
//     });
// };

// export const del = async (endpoint: string, data?: any) => {
//   return fetch(BASE_URL + endpoint, {
//     method: RequestTypes.delete,
//     headers: {
//       Accept: "application/json",
//       "Content-Type": "application/json",
//     },
//   })
//     .then((response) => response.json())
//     .then((json) => {
//       return json;
//     })
//     .catch((error) => {
//       console.error(error, "error");
//     });
// };
// export const put = async (endpoint: string, data: any) => {
//   return fetch(BASE_URL + endpoint, {
//     method: RequestTypes.put,
//     headers: {
//       Accept: "application/json",
//       "Content-Type": "application/json",
//     },
//     body: JSON.stringify(data),
//   })
//     .then((response) => response.json())
//     .then((json) => {
//       return json;
//     })
//     .catch((error) => {
//       console.error(error, "error");
//     });
// };
// export const patch = async (endpoint: string, data: any) => {
//   return fetch(BASE_URL + endpoint, {
//     method: RequestTypes.patch,
//     headers: {
//       Accept: "application/json",
//       "Content-Type": "application/json",
//     },
//     body: JSON.stringify(data),
//   })
//     .then((response) => response.json())
//     .then((json) => {
//       return json;
//     })
//     .catch((error) => {
//       console.error(error, "error");
//     });
// };
